import React, { useEffect, useState } from 'react';
import NavBar from '../NavBar/NavBar';
import Content from '../Content/Content';
import Main from '../../landing/Main';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export default function HomePage(props) {
  var time = null;
  const [isSet, SetIsSet] = React.useState(false)
  const urlval = useLocation();

  useEffect(() => {
    if (!time) {
      props.timer2();
      time = true;
    }
    return () => props.timer2(urlval);
  }, [props.timer2])

  return (
    <div className={`container-fluid p-0 m-0 ${props.pathname}`}>
      <Helmet>
        <title>{`${props?.pathname?.partner_name} | Calque`}</title>
        <meta name="description" content={`${props?.pathname?.partner_name} has partnered with Calque to bring you a new, innovative lending solution called The Trade-In Mortgage™.`} />
        <meta name="keywords" content="trade in mortgage, trade-in mortgage, trade in loan, trade up mortgage, slide loan, slide mortgage, glide loan, trade my home, home swap, mortgage swap, swamp my home, home trade, buy before you sell, buy-first solution, buy-first, Calque, house swap" />
        <meta property="og:title" content={`${props?.pathname?.partner_name} | Calque`} />
        <meta property="og:description" content={`${props?.pathname?.partner_name} has partnered with Calque to bring you a new, innovative lending solution called The Trade-In Mortgage™.`}/>
        <meta property="og:url" content={`https://tradeinmortgage.com/${props?.pathname?.url_path}`} />
        <link rel="canonical" href={`https://tradeinmortgage.com/${props?.pathname?.url_path}`} />
      </Helmet>
      {
        props.pathname.partner_id ?
          <>
            <NavBar {...props} partner={props.pathname} contactGlobal={props.contactGlobal} emailGlobal={props.emailGlobal} calendlyUrl={props.calendlyUrl} addressGlobal={props.addressGlobal} />
            <Content {...props} SetIsSet={SetIsSet} isSet={isSet} contactGlobal={props.contactGlobal} emailGlobal={props.emailGlobal} calendlyUrl={props.calendlyUrl} addressGlobal={props.addressGlobal} partner={props.partner} pathname={props.pathname} GAtimer={props.GAtimer} GAtimerFinish={props.GAtimerFinish} partnerContactRole={props.partnerContactRole} condition={props.condition} aboutUsList={props.aboutUsList} conditionList={props.conditionList} defectsList={props.defectsList}/>
          </>
          :
          <>
            <Main {...props} setEfficientDefault={props.setEfficientDefault} efficientDefault={props.efficientDefault} handleEfficientDefault={props.handleEfficientDefault} contactGlobal={props.contactGlobal} emailGlobal={props.emailGlobal} calendlyUrl={props.calendlyUrl} addressGlobal={props.addressGlobal} partner={props.partner} GAtimer={props.GAtimer} GAtimerFinish={props.GAtimerFinish} condition={props.condition} aboutUsList={props.aboutUsList} conditionList={props.conditionList} defectsList={props.defectsList}/>
          </>
      }
    </div>
  )
}